import { createRoot } from 'react-dom/client';
import { getMediaQuerySizesFromAttributes } from '@repo/common-utils/mediaQueryAttributeInputHelper';
import { getYesAttribute } from '@repo/widget-utils/attributes/attribute-helper';
import { getCsvColorsAttributes } from '@repo/widget-utils/attributes/color-attribute-helper';
import { getCsvProductCatalogAttributes } from '@repo/widget-utils/attributes/product-catalog-attribute-helper';
import ProductCardList from 'src/widgets/activities/product/product-list-2/product-card-list-2/ProductCardList2';
import BilberryCustomElement from 'src/widgets/BilberryCustomElement';
import { WidgetWrapper } from 'src/widgets/WidgetWrapper';
import createWebComponentTagName from 'src/utils/widget/createWebComponentTagName';

class BilberryProduct extends BilberryCustomElement {
    protected renderWidget(): void {
        const productCatalogAttributes = getCsvProductCatalogAttributes(this);
        const productCollectionId = this.getAttribute('product-collection-id');
        const isTimeslots = getYesAttribute(this, 'timeslots');

        const scrollAttribute = this.getAttribute('scroll');
        const scroll = !(scrollAttribute && scrollAttribute!.toString().toLowerCase() === 'no');
        const colors = getCsvColorsAttributes(this);

        const numElements = getMediaQuerySizesFromAttributes(this, 1, 2, 2, 3);

        createRoot(this._mountPoint).render(
            <WidgetWrapper
                mountPoint={this._mountPoint}
                popoverMountPoint={this._popoverMountPoint}
                shadowRoot={this._shadowRoot}
            >
                <ProductCardList
                    productCatalogAttributes={productCatalogAttributes}
                    scroll={scroll}
                    numElements={numElements}
                    backgroundColors={colors.backgroundColors}
                    textColors={colors.textColors}
                    primaryColors={colors.primaryColors}
                    primaryTextColors={colors.primaryTextColors}
                    accentColors={colors.accentColors}
                    accentTextColors={colors.accentTextColors}
                    isTimeslots={isTimeslots}
                    productCollectionId={
                        productCollectionId ? parseInt(productCollectionId) : undefined
                    }
                />
            </WidgetWrapper>,
        );
    }
}

export default function defineCustomElement(): void {
    customElements.define(
        createWebComponentTagName('bilberry-product-list', 'v2'),
        BilberryProduct,
    );
}
